import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SolicitudRequestDTO } from '../../models/solicitud/solicitud-request.dto';
import { environment as ENV} from '../../../environments/environment';
import { URL_MAP } from '../../shared/urlMap';

@Injectable({
  providedIn: 'root',
})
export class SolicitudService {
  // private apiUrl = environment.EXTERNAL.serviceSolicitud; // URL de la API para radicar la solicitud
  private apiUrl = `${ENV.HOST}${URL_MAP.EXTERNAL.serviceSolicitud}`;
  constructor(private http: HttpClient) {}

  radicarSolicitud(solicitud: SolicitudRequestDTO): Observable<any> {
    console.log('Objeto que se enviara:', solicitud);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });

    return this.http.post(this.apiUrl, solicitud, { headers });
  }
}
